module.exports = __webpack_public_path__ + "static/media/gallery-25.d0f4210e.jpg";